import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

export interface MenuDrawerNavLinkElementProps {
  to?: string;
  onClick: () => void;
  shouldShow: boolean;
  children: ReactNode;
  end?: boolean;
}

const MenuDrawerNavLinkElement = ({
  children,
  onClick,
  to,
  end,
}: {
  children: ReactNode;
  onClick: () => void;
  to?: string;
  end?: boolean;
}) => {
  const className =
    'flex flex-row gap-x-3 items-center [&.active]:text-blue-light font-bold text-gray-800 cursor-pointer';

  if (to)
    return (
      <NavLink className={className} end={end} to={to} onClick={onClick}>
        {children}
      </NavLink>
    );

  return (
    <div className={className} onClick={onClick}>
      {children}
    </div>
  );
};

export default MenuDrawerNavLinkElement;
